import {observer} from "mobx-react-lite";
import appStore from "../../../storage/AppStore";
import React, {useEffect, useState} from "react";
import clubStore from "../../../storage/ClubStore";
import systemStore from "../../../storage/SystemStore";
import {Link} from "react-router";
import {Card} from "primereact/card";
import {Divider} from "primereact/divider";
import {useLocation, useNavigate} from 'react-router-dom'
import {Button} from 'primereact/button'

const TopDebts = () => {
  const location = useLocation()
  const navigate = useNavigate()
  useEffect(() => {
    clubStore.billing.getTopDebts()
  }, [location.pathname]);
  if (clubStore.billing.top_debts.length === 0) {
    return null;
  }
  return (
    <Card className="attendance-card shadow-2 border-round mb-3">
      <div className="attendance-card-header">
        <span className="attendance-card-title">
            {appStore.tr.debts}
        </span>
      </div>
      
      <Divider className="attendance-divider"/>
      
      {clubStore.billing.top_debts.map((debt, index) => (
        <div key={index} className="attendance-month">
          <div className="attendance-list">
            <div className="attendance-row">
              <Link
                to="/manager/billing/info"
                onClick={() => {
                  clubStore.billing.query.setProperty('page_number', 1)
                  clubStore.billing.query.setProperty('company_user_id', debt.company_user_id)
                  clubStore.billing.search()
                }}
                className="attendance-link"
              >
                {debt.title}
              </Link>
              <span className="attendance-count">
                            <strong>{debt.amount}</strong>
                        </span>
            </div>
          </div>
          <Divider className="attendance-divider spaced"/>
        </div>
      ))}
    </Card>
  
  );
}
export default observer(TopDebts)